/**
 * Formats a number as a price string with a currency symbol.
 * 
 * @param {number} price - The price number to format.
 * @param {string} [currency='$'] - The currency symbol to prepend.
 * @returns {string} The formatted price string (e.g., "$99.99").
 */
export const formatPrice = (price, currency = '$') => {
  // Ensure price is a number and handle potential null/undefined values gracefully
  const numericPrice = Number(price);
  if (isNaN(numericPrice)) {
    // Optionally return a placeholder or empty string if price is not valid
    console.warn('Invalid price value provided to formatPrice:', price);
    return ''; // Or return a default like '$0.00' or 'N/A'
  }
  return `${currency}${numericPrice.toFixed(2)}`;
}; 